import React from 'react'
import { Alert, ButtonPrimary, Flex, Text } from 'front-end/src/components'
import { brandColors } from 'shared/basicPalette'
import IconInfo from 'front-end/src/components/common/icon/IconInfo'
import { Trans } from '@lingui/macro'
import { NbSp } from 'front-end/src/utils/NbSp'
import { linkBuilder } from 'shared/linkBuilder'
import { useManageEventContext } from 'front-end/src/pages/manage-events/ManageEventContext'
import { navigateTo } from 'front-end/src/app/util/appHistory'

export const ManageEventNotification = () => {
  const { event } = useManageEventContext()

  if (!event?.recurring_event_id) {
    return null
  }

  return (
    <Alert
      bgColor={brandColors.yellow['50']}
      status="warning"
      justifyContent="space-between"
      mb="16px"
    >
      <Flex align="center">
        <IconInfo fontSize="24px" m="6px" mr="14px" />
        <Text>
          <Trans>
            You're viewing an
            <NbSp />
            <strong>event occurrence</strong>
          </Trans>
        </Text>
      </Flex>
      <ButtonPrimary
        dataTest="ShowWholeSeriesButton"
        onClick={() =>
          navigateTo(
            linkBuilder.manageEvent(
              // @ts-ignore
              event.recurring_event_id,
              true,
              'occurrences'
            )
          )
        }
      >
        <Trans>Show whole Series</Trans>
      </ButtonPrimary>
    </Alert>
  )
}
